export default `
    <ul
        # if (data.id) { # id="#= data.prefix || "" ##= data.id #" # } #
        # if (data.classes || data.bsc) { # class="#= data.classes # #=data.bsc||""#" # } #
        # if (data.dataValue) { # data-value="#= data.dataValue #" # } #
    >
        #= data.contents #
    </ul>
`;
